<template>
  <v-container>
    <v-row>
      <v-col>
        <h1>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon
                     @click="$router.push({name: 'party', params: {partyId: party.id}})"
                     v-on="on"
              >
                <v-icon x-large>mdi-chevron-left</v-icon>
              </v-btn>
            </template>
            <span>Go Back</span>
          </v-tooltip>
          {{ scenario.select_text }}
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6">
        <v-card>
          <v-card-title>Scenario Information</v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12">
                <div class="subtitle-2">General Information</div>
                <div>
                  Availability: {{ availability }}
                </div>
                <div>
                  Required: {{ scenario.required }}
                </div>
                <div>
                  Rewards: {{ unlocksAchievements }}
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider/>

          <v-card-actions>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon
                       color="primary"
                       @click="completeScenario()"
                       v-on="on"
                >
                  <v-icon>mdi-check</v-icon>
                </v-btn>
              </template>
              <span>Complete Scenario</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon
                       color="red"
                       @click="detachScenario()"
                       v-on="on"
                >
                  <v-icon>mdi-cancel</v-icon>
                </v-btn>
              </template>
              <span>Undo Scenario</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6">
        <v-card>
          <v-card-title>Conclusion</v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12">
                <div>
                  <template v-for="(line, linekey) in scenario.conclusion.split('\n')">{{ line }}<br :key="linekey">
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="mt-6">
          <v-card-title>Previous Scenarios</v-card-title>

          <v-card-text>
            <div v-for="(unlockedByScenario, unlockedByScenarioIndex) in scenario.unlocked_by"
                 :key="unlockedByScenarioIndex">
              <span style="cursor: pointer;"
                    @click="openScenario(unlockedByScenario.id)">{{ unlockedByScenario.select_text }}</span>
            </div>
          </v-card-text>
        </v-card>

        <v-card class="mt-6">
          <v-card-title>Next Scenarios</v-card-title>

          <v-card-text>
            <div v-for="(unlocksScenario, unlocksScenarioIndex) in scenario.unlocks" :key="unlocksScenarioIndex">
              <span style="cursor: pointer;"
                    @click="openScenario(unlocksScenario.id)">{{ unlocksScenario.select_text }}</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import PartyService from "../services/PartyService";
import ScenarioService from "../services/ScenarioService";

export default {
  data: () => ({
    scenario: {
      id: Number,
      number: Number,
      conclusion: String,
      select_text: String,
      required: String,
      unlocks: [
        {
          id: Number,
          title: String
        }
      ],
      unlocks_achievements: [
        {
          id: Number,
          title: String
        }
      ]
    },
    party: {
      id: Number,
      campaign: {
        id: Number
      },
      available_scenarios: [
        {
          id: Number
        }
      ]
    }
  }),

  computed: {
    unlocksScenarios: function () {
      let unlocks = "";

      this.scenario.unlocks.forEach((unlock) => {
        unlocks += " " + unlock.select_text;
      });

      return unlocks;
    },

    unlocksAchievements: function () {
      let unlocks = "";

      this.scenario.unlocks_achievements.forEach((unlock) => {
        unlocks += " " + unlock.title + " (" + unlock.type + ")";
      });

      return unlocks;
    },

    availability: function () {
      let scenario = this.party.available_scenarios.filter(scenario => scenario.id === parseInt(this.$route.params.scenarioId));

      if (!scenario.length)
        return "Locked";

      if (scenario[0].is_complete)
        return "Finished";

      if (!scenario[0].is_accessible)
        return "Unlocked but unavailable"

      return "Available";
    }
  },

  created() {
    this.viewScenario();
    this.viewParty();
  },

  methods: {
    viewScenario() {
      ScenarioService.view(this.$route.params.scenarioId)
          .then(response => {
            this.scenario = response.data.data;
          })
          .catch(err => {
            console.log(err);
          });
    },

    viewParty() {
      PartyService.view(this.$route.params.partyId)
          .then(response => {
            this.party = response.data.data;
          })
          .catch(err => {
            console.log(err);
          });
    },

    completeScenario() {
      ScenarioService.completeByParty(this.scenario.id, this.$route.params.partyId)
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            this.$router.push({name: 'party', params: {partyId: this.$route.params.partyId}});
          });
    },

    detachScenario() {
      PartyService.detachScenario(this.party.id, {
        scenario_id: this.scenario.id
      })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            this.$router.push({name: 'party', params: {partyId: this.$route.params.partyId}});
          });
    },

    openScenario(scenarioId) {
      this.$router.push({name: 'scenario', params: {scenarioId: scenarioId, partyId: this.party.id}});
      this.viewScenario();
    }
  }
};
</script>